"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentViewOnlineDriversEdController = /** @class */ (function () {
    function AdminStudentViewOnlineDriversEdController($state, $stateParams, UsersModel, FlashService, OnlineDriversEd) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.OnlineDriversEd = OnlineDriversEd;
        this.submitted = false;
        this.pageBy = 5;
        this.currentPage = 1;
        this.loading = true;
        this.finals = [];
        OnlineDriversEd.viewFinals({
            student_id: $stateParams.userId,
            page_by: this.pageBy,
        }).then(function (response) {
            _this.finals = response.online_drivers_ed_finals.data;
            _this.currentPage = response.online_drivers_ed_finals.current_page;
            _this.totalItems = response.online_drivers_ed_finals.total;
            _this.loading = false;
        });
    }
    AdminStudentViewOnlineDriversEdController.prototype.formatDate = function (datestring) {
        return new Date(datestring).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    AdminStudentViewOnlineDriversEdController.prototype.pageChanged = function () {
        var _this = this;
        this.submitted = true;
        this.OnlineDriversEd.viewFinals({
            student_id: this.$stateParams.userId,
            page_by: this.pageBy,
        })
            .then(function (response) {
            _this.finals = response.online_drivers_ed_finals.data;
            _this.currentPage = response.online_drivers_ed_finals.current_page;
            _this.totalItems = response.online_drivers_ed_finals.total;
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return AdminStudentViewOnlineDriversEdController;
}());
AdminStudentViewOnlineDriversEdController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "OnlineDriversEd",
];
exports.default = AdminStudentViewOnlineDriversEdController;
